module.exports = __webpack_public_path__ + "img/home_fcst.0b70bc07.png";